import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'frontbucket.repository.source.sidebar.newUserCard.header',
    description: 'Header for the new user sidebar card',
    defaultMessage: 'Welcome to Bitbucket',
  },
  intro: {
    id: 'frontbucket.repository.source.sidebar.newUserCard.intro',
    description: 'Intro content for the new user sidebar card',
    defaultMessage:
      'Congratulations on making it into a repository! Here’s where you store files.',
  },
  contents: {
    id: 'frontbucket.repository.source.sidebar.newUserCard.contents',
    description: 'Contents for the new user sidebar card',
    defaultMessage:
      'Whether you were invited or it’s your first one, check out our ' +
      '{guide} for a basic introduction to Bitbucket and repositories.',
  },
});
